export const stickyLineupBtn = () => {
  if (document.querySelector(".js-sticky-lineup-link") === null) {
    return;
  }

  const el = document.querySelector(".js-sticky-lineup-link");
  const target = document.querySelector(".js-about-section");

  const triggerPoint = target.offsetTop + target.offsetHeight - 200;

  window.addEventListener("scroll", function () {
    // 現在のスクロール位置が triggerPoint を超えたらクラス追加、そうでなければ削除
    if (window.pageYOffset >= triggerPoint) {
      el.classList.add("is-hidden");
    } else {
      el.classList.remove("is-hidden");
    }
  });
};
